import { StrictMode, type ReactNode } from "react";
import { createRoot, type Root } from "react-dom/client";
import { ThemeProvider } from "./theme";

// Mount a page into #root, wrapped in the theme provider. The root is cached on
// the container so Bun's dev HMR (which re-executes the entry module) reuses it
// instead of calling createRoot() twice on the same node.
export function mount(app: ReactNode): void {
  const container = document.getElementById("root") as
    | (HTMLElement & { _reactRoot?: Root })
    | null;
  if (!container) throw new Error("#root element not found");
  const root = (container._reactRoot ??= createRoot(container));
  root.render(
    <StrictMode>
      <ThemeProvider>{app}</ThemeProvider>
    </StrictMode>
  );
}
